// removed by extract-text-webpack-plugin
module.exports = {"receipt-info-box":"app-components-receipt-transactions-InfoBox-__InfoBox___2iAL6","receipt-date":"app-components-receipt-transactions-InfoBox-__InfoBox___BVOwA","receipt-number":"app-components-receipt-transactions-InfoBox-__InfoBox___2crGL","receipt-served":"app-components-receipt-transactions-InfoBox-__InfoBox___iti4m","receipt-collected":"app-components-receipt-transactions-InfoBox-__InfoBox___2RPR8"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/transactions/InfoBox/InfoBox.css
// module id = 754
// module chunks = 0